import {h, Fragment} from "preact"
import { useActions } from '@nosto/preact'

export default ({ activeFilters, products, facets }) => {
    const { updateSearch, toggleProductFilter } = useActions();

    return (
        <>
            {activeFilters.length > 0 && (
                <div class="ns-active-filters-container">
                    {activeFilters.map((filter) => {
                        return (
                            <div className={`ns-filter-remove`}>
                                <span class="ns-facet-item ns-font-3 ns-no-wrap">{filter.value}</span>
                                <button type="button" class="CollectionFilters__Modal-Close ns-close-sort filter" onClick={(e) => {
                                    toggleProductFilter(
                                        filter.facetField,
                                        filter.value,
                                        false
                                    )
                                }}>
                                    <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <line x1="-2" y1="7.5" x2="17.1993007" y2="7.5" id="Line-2" transform="translate(7.599650, 7.500000)
                                        rotate(45.000000)
                                        translate(-7.599650, -7.500000)
                                        ">
                                                    </line>
                                                    <line x1="-2" y1="7.62454212" x2="17.1993007" y2="7.62454212" id="Line-2" transform="translate(7.599650, 7.624542)
                                        rotate(-45.000000)
                                        translate(-7.599650, -7.624542)
                                        ">
                                                    </line>
                                    </svg>
                                </button>
                            </div>
                        )
                    })}
                </div>
            )}
        </>
    )
}